export function formatStreetAddress({ address1, address2 }) {
  if (address2 == null || address2 === '') return address1;

  return `${address1} ${address2}`;
}

export function formatFullAddress(address) {
  const { city, state, stateCode, postalCode } = address;
  const streetAddress = formatStreetAddress(address);
  return `${streetAddress}, ${city}, ${state || stateCode} ${postalCode}`;
}
